<template>
    <div class="book-shelf-page">
        <StateWrapper
            :content=" data && data.salons"
            :loadingStatus="loadingStatus"
            :checkLogin="false"
        >
            <AdminPageTitle :title="'События'" class="mt-10"/>
            <div class="wrapper">
                <AppButton
                v-if="!showSalonForm"
                @click="showSalonForm=true"
                class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                >
                    <span>Добавить</span>
                </AppButton>
                <v-dialog 
                    v-model="showSalonForm"
                    transition="dialog-bottom-transition"
                    fullscreen
                    >
                    <v-card>
                <v-card-title class="card_ligth_header">
                    <h5 v-if="!!this.id">Редактирование события</h5>
                    <h5 v-else>Добавление события</h5>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form ref="salonForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        label="Заголовок*"
                        v-model="salonName"
                        :counter="250"
                        variant="outlined"
                        hint="Укажите заголовок"
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="pb-16" style="height: 350px;">
                    <TextEditor class="mb-3" :value="salonAnnonce" @update:value="onSalonAnnonceUpdate" />
                  </v-col>
                  <v-col cols="12" class="pb-16" style="height: 1250px;">
                    <TextEditor class="mb-3" :value="salonDescription" @update:value="onSalonDescriptionUpdate" />
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete
                        v-model="salonType"
                        :items="eventTypes"
                        outlined
                        dense
                        variant="outlined"
                        label="Тип"
                        item-title="name"
                        item-value="id"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" v-if="salonType===1">
                    <v-autocomplete
                        v-model="webinarId"
                        :items="webinars"
                        outlined
                        dense
                        item-title="webinarName"
                        item-value="id"
                        label="Вебинар"
                        required
                    >
                      <template v-slot:item="{ props, item }">

                        <v-list-item
                            v-bind="props"
                            :title="item.raw.webinarName"

                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>


                  <v-col cols="12" v-if="salonType===2">
                    <v-text-field
                        label="Внешняя ссылка*"
                        v-model="externalLink"
                        :counter="250"
                        variant="outlined"
                        hint="Укажите ссылку"
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" v-if="salonType===2">
                    <v-text-field
                        label="Описание ссылки*"
                        v-model="externalLinkDescription"
                        :counter="250"
                        variant="outlined"
                        hint="Укажите описание ссылки"
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-label>Дата проведения*</v-label>
                    <datePicker
                        v-model="salonDate"
                        autoApply
                        inline
                        textInput
                        locale="ru"
                    />
                  </v-col>

                  <v-col cols="12" class="py-16">
                    <v-autocomplete
                        v-model="videoFiles"
                        :items="sourceVideoFiles"
                        clearable
                        return-object
                        multiple
                        outlined
                        dense
                        small-chips
                        chips
                        closable-chips
                        item-title="videoDescription"
                        label="Видео"
                        v-on:click:clear="videoFiles = []"
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                            v-bind="props"
                            :text="item.raw.videoDescription && item.raw.videoDescription.length>30 ? item.raw.videoDescription.substring(0, 28) + '...' : item.raw.videoDescription"
                        ></v-chip>
                      </template>
                      <template v-slot:item="{ props, item }">

                        <v-list-item
                            v-bind="props"
                            :title="item.raw.videoDescription"
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>


                  <v-col cols="12" class="py-16">
                    <v-row
                        class="px-4"
                        fluid
                    >
                      <v-switch
                          v-model="published"
                          :label="'Опубликовано'"
                          color="success"
                      >
                      </v-switch>
                      <v-chip class="ma-2" v-if="published"> Опубликовано</v-chip><v-chip v-else class="ma-2"> Не опубликовано</v-chip>
                    </v-row>
                  </v-col>


                </v-row>
              </v-container>
              <small>*обязательно для заполнения</small>
            </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="card_ligth_actions">
                    <v-spacer></v-spacer>
                    <AppButton
                        class="admin-lib__opener d-flex flex__ai-c"
                        @click="closeSalonForm"
                    >
                        <span>Закрыть</span>
                    </AppButton>
                    <AppButton
                        class="admin-lib__opener d-flex flex__ai-c"
                        @click="saveSalon"
                    >
                        <span>Сохранить</span>
                    </AppButton>
                </v-card-actions>
                    </v-card>
                </v-dialog>
                
                <div class="book-shelf-page__results">
                    <div class="book-shelf-page__items" v-if="data && data.salons">
                        <AccordionItemWithEdit
                v-for="(v, idx) in data.salons"
                :key="v.id"
                :isOpen="currentId === v.id"
                @open="setCurrentId"
                :style="{ 'animation-delay': `0.${idx}s` }"
                :id="v.id"
            >
              <template v-slot:top>
                <span v-if="v.salonName">{{ v.salonName }} <span v-if="!!v.eventDateTime">({{ formatDate(v.salonDate) }})</span></span> 
              </template>
              <template v-slot:bottom>
                <div class="ma-2">
                  <h3>Анонс:</h3>
                  <div class="book-shelf-page__chips" v-html="v.salonAnnonce">
                  </div>
                </div>
                <v-divider color="accent" class="mt-8"></v-divider>
                <div class="ma-2">
                    <v-row>
                        <v-spacer></v-spacer>
                        <AppButton
                        @click="deleteSalon(v)"
                            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                        >
                            <span>Удалить</span>
                        </AppButton>
                        <AppButton
                            @click="editSalon(v)"
                            class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                        >
                            <span>Редактировать</span>
                           
                        </AppButton>
                    </v-row>
                   
                </div>

              </template>
                        </AccordionItemWithEdit>
                    </div>
                    <div class="flex flex__jc-c" v-if="!!data && data.salons">
                        <vue-awesome-paginate
                            :total-items="data.salonsCount"
                            v-model="currentPage"
                            :items-per-page="itemsPerPage"
                            :max-pages-shown="maxPagesShown"
                            @click=updatesalons()
                        />
                    </div>
                </div>
            </div>
        </StateWrapper>
    </div>
  </template>
  
  <script>
import TextEditor from "@/components/TextEditor.vue";
  import { onMounted, ref, computed } from "vue";
  import { t } from "@/utils/translate";
  import { customAxios } from "@/service/customAxios";
  import AccordionItemWithEdit from "@/components/AccordionItemWithEdit.vue";
  import AdminPageTitle from "@/elements/AdminPageTitle.vue";
  import StateWrapper from "@/components/StateWrapper.vue";
  import { setCurrentIdValue } from "@/utils/common";
  import AppButton from "@/elements/AppButton.vue";
  import { required, maxLength, helpers } from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import { usePopupStore } from "@/store/popupStore";

  export default {
    components: {
      StateWrapper,
      AdminPageTitle,
      AccordionItemWithEdit,
      AppButton,
      TextEditor
    },
    setup() {
        const salonName = ref("");
        const salonAnnonce = ref("");
        const salonDescription = ref("");
        const salonDate = ref("");
        const salonType = ref(1);
        const externalLink = ref("");
        const externalLinkDescription = ref("");
        const published = ref(false);
        const webinars = ref([]);
        const showSalonForm = ref(false);
        const salons = ref ([]);
        const sourceVideoFiles = ref([]);
        const videoFiles = ref([]);
        const webinarId = ref("");
    

        const id = ref();
        const errorBody = ref("");
        const { showPopup } = usePopupStore();
        const eventTypes = ref( [
            { name: "Вебинар", id: 1 },
            { name: "Внешняя ссылка", id: 2},
            { name: "Без ссылки", id: 3},
        ]);

        const rules = {
            salonName: {
                required: helpers.withMessage("Обязательное поле", required),
                max: helpers.withMessage("Не более 250 символов", maxLength(250)),
            },
            salonAnnonce: {
                required: helpers.withMessage("Обязательное поле", required),
                max: helpers.withMessage("Не более 1500 символов", maxLength(1500)),
            },
            externalLink: {
                max: helpers.withMessage("Не более 250 символов", maxLength(250)),
            },
    };

    const v$ = useVuelidate(rules, {
        salonName: salonName,
        salonAnnonce: salonAnnonce,
    });
    
    const loadingStatus = ref("loading");
    const currentId = ref(null);
    const data = ref([]);
    const maxPagesShown = ref(5);
    const itemsPerPage = ref(25);
    const currentPage = ref(1);

    function setCurrentId(value) {
        currentId.value = setCurrentIdValue(value, currentId.value);
    }
    
    const saveIsDisable = computed(() => {
        return checkInvalidation();
    });

    function checkInvalidation() {
        v$.value.$touch();
    return v$.value.$invalid;
    }
    function onSalonAnnonceUpdate(e){
        salonAnnonce.value = e;
    }

    function formatDate(dateString) {
      let formatter = new Intl.DateTimeFormat("ru", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });

      return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
    }



    async function updateSalons(){
        data.value = await getSalons();
        salons.value = data.value.salons;
    }

    async function getSalons() {
        try {
            const r = await customAxios.post("salon/paginated",{
            page: currentPage.value,
            notePerPage: itemsPerPage.value,
            });
            loadingStatus.value = "loaded";
            console.log("r.data:" + r.data)
            return r.data;
        } catch (e) {
            loadingStatus.value = "error";
            console.log(e);
        }
    }
    function capitalizeFirstLetter(string) {
        if(string && string.length>0){
            return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
            return ''
        }
    }
    async function getWebinars() {
        try {
            const r = await customAxios.get("webinar");
            loadingStatus.value = "loaded";
            return r.data;
        } catch (e) {
            loadingStatus.value = "error";
            console.log(e);
        }
    }

    async function getVideos() {
        try {
            const r = await customAxios.get("library/video");
            loadingStatus.value = "loaded";
            return r.data;
        } catch (e) {
            loadingStatus.value = "error";
            console.log(e);
        }
    }
    

    function editSalon(item){
        id.value=item.id;
        salonName.value=item.salonName;
        salonAnnonce.value=item.salonAnnonce;
        salonDescription.value=item.salonDescription;
        salonDate.value=item.salonDate;
        salonType.value=item.salonType;
        externalLink.value = item.externalLink;
        externalLinkDescription.value = item.externalLinkDescription;
        webinarId.value = item.webinarId;
        published.value = item.published;
        videoFiles.value = item.videoFiles;
        showSalonForm.value=true;
    }

    function closeSalonForm(){
        id.value=undefined;
        salonName.value="";
        salonAnnonce.value="";
        salonDescription.value="";
        salonDate.value="";
        salonType.value="";
        externalLink.value ="";
        externalLinkDescription.value = "";
        webinarId.value = "";
        published.value = false;
        videoFiles.value = "";
        showSalonForm.value=false;
    }

    function onSalonDescriptionUpdate(e) {
        salonDescription.value = e
    }

    async function saveSalon() {
        if(saveIsDisable.value){
            showPopup("Не все поля заполнены! Сохранение не доступно", "warning");
            return
        }
        errorBody.value=''
        console.log("in save")
            let salon = {
              salonName: capitalizeFirstLetter(salonName.value),
              salonAnnonce: capitalizeFirstLetter(salonAnnonce.value),
              salonDescription: salonDescription.value,
              salonDate: salonDate.value,
              salonType: salonType.value,
              externalLink: externalLink.value,
              externalLinkDescription: externalLinkDescription.value,
              webinarId: webinarId.value,
              published: published.value,
              videoFiles: videoFiles.value,
            }
            if (id.value) {
                try{
                    const r = await customAxios.put('salon/' + id.value, salon) 
                    if(r.status===202){ 
                        closeSalonForm();
                        showPopup("Событие успешно обновлено!", "success");
                        updateSalons();
                    }
                } catch (e) {
                    if(e.response && e.response.data && e.response.data.message){
                        errorBody.value = e.response.data.message;
                    } else {
                        errorBody.value = t("something.went.wrong");
                    }
                }
            } else {
                try{
                    const r = await  customAxios.post('salon', salon);
                    if(r.status===201){
                        closeSalonForm();
                        updateSalons();
                        showPopup("Событие успешно добавлено!", "success");
                    }
                } catch(e){
                    if(e.response && e.response.data && e.response.data.message){
                        errorBody.value = e.response.data.message;
                    } else {
                        errorBody.value = t("something.went.wrong");
                    }
                }
            }
    }

    async function deleteSalon(event){
        try {
            const r = await customAxios.delete('salon/' + event.id)
            console.log("r: " + r);
            if(r.status===202){
                showPopup(r.data.message, "success");
                updateSalons();
            }
        } catch (e) {
            if(e.response && e.response.data && e.response.data.message){
                showPopup(e.response.data.message, "error");
            } else {
                showPopup(t("something.went.wrong"), "error");
            }
        }
    }
    
    onMounted(async () => {
        data.value = await getSalons();
        sourceVideoFiles.value = await getVideos();
        webinars.value = await getWebinars();
    });


    return {
        t,
        salonName,
        salonAnnonce,
        salonDescription,
        salonDate,
        salonType,
        externalLink,
        externalLinkDescription,
        published,
        webinars,
        webinarId,
        showSalonForm,
        salons,
        videoFiles,
        sourceVideoFiles,
        id,
        errorBody,
        eventTypes,
        rules,
        currentId,
        formatDate,
        v$,
        saveIsDisable,
        deleteSalon,
        saveSalon,
        closeSalonForm,
        data,
        editSalon,
        setCurrentId,
        loadingStatus,
        maxPagesShown,
        itemsPerPage,
        currentPage,
        onSalonAnnonceUpdate,
        onSalonDescriptionUpdate

      };
    },
  };
  </script>
  
  <style lang="scss">
  .book-shelf-page {
    text-align: center;
  
    &__chips {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
  
      span {
        color: $accent-1;
        border: 1px dashed $accent-1;
        padding: 8px;
        margin: 8px;
        border-radius: 10px;
      }
    }
  
    &__filters {
      text-align: left;
      margin-bottom: 60px;
    }
  
    &__filters-title {
      margin-bottom: 10px;
    }
  
    &__theme {
      @include button-default-not-accent;
      display: none;
      margin-right: 8px;
  
      &.active {
        display: flex;
      }
  
      &.current {
        background-color: $accent-1;
        color: #fff;
      }
    }
  
    &__search {
      margin-bottom: 60px;
    }
  
    .wrapper {
      @include page;
    }
    ul{
      margin-left: 40px;
    }
  
    &__items {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 40px;
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
    }
  
    &__btn {
      @include button-default-not-accent;
  
      &.active {
        @include button-default;
      }
  
      & + .book-shelf-page__btn {
        margin-left: 16px;
      }
    }
  }
  </style>
  